import { StaticBaseDao } from '@/dao';
import {
    Participant,
    IntArray,
    PostResponse,
    MergeParticipantsRequest,
    ParticipantSearchRequest,
    ParticipantLicenceResponse,
    ParticipantID,
    SearchRequest,
    TypeAheadItem,
} from '@/objects/generated';
import { useUserStore } from '@/stores';

export class ParticipantDao extends StaticBaseDao {
    public static async Participants(uids: number[], detailed: boolean): Promise<Participant[]> {
        return this.BaseFetchArray(
            Participant,
            `Participant/Participants` +
                '?' +
                (uids == undefined ? '' : `${this.makeGetStringFromList(uids, 'uids')}`) +
                '&' +
                (detailed == undefined ? '' : `detailed=${detailed}`),
            'GET',
        );
    }
    public static async MarkAsNotDuplicates(uids: IntArray): Promise<PostResponse | null> {
        return this.BaseFetch(PostResponse, `Participant/MarkAsNotDuplicates`, 'POST', uids);
    }
    public static async Merge(mergeParticipantsRequest: MergeParticipantsRequest): Promise<PostResponse | null> {
        return this.BaseFetch(PostResponse, `Participant/Merge`, 'POST', mergeParticipantsRequest);
    }
    public static async ParticipantSearch(searchRequest: ParticipantSearchRequest): Promise<Participant[]> {
        return this.BaseFetchArray(Participant, `Participant/ParticipantSearch`, 'POST', searchRequest);
    }
    public static async ParticipantLicenceSearch(searchRequest: ParticipantSearchRequest): Promise<ParticipantLicenceResponse | null> {
        return this.BaseFetch(ParticipantLicenceResponse, `Participant/ParticipantLicenceSearch`, 'POST', searchRequest);
    }
    public static async GetParticipants(uids: IntArray, eventId: number): Promise<Participant[]> {
        return this.BaseFetchArray(
            Participant,
            `Participant/GetParticipants` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`),
            'POST',
            uids,
        );
    }
    public static async SaveParticipants(participants: Participant[]): Promise<IntArray | null> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return null;
        }
        return this.BaseFetch(IntArray, `Participant/SaveParticipants`, 'POST', participants);
    }
    public static async GetParticipantIDForTypes(ids: IntArray, participantID: number): Promise<ParticipantID[]> {
        return this.BaseFetchArray(
            ParticipantID,
            `Participant/GetParticipantIDForTypes` + '?' + (participantID == undefined ? '' : `participantID=${participantID}`),
            'POST',
            ids,
        );
    }
    public static async ParticipantTypeaheadSearch(request: SearchRequest): Promise<TypeAheadItem[]> {
        return this.BaseFetchArray(TypeAheadItem, `Participant/ParticipantTypeaheadSearch`, 'POST', request);
    }
}
